import React, { useMemo } from 'react';

// styles
import { StyledBasicCheckbox } from './style';

// libraries
import { uniqueId } from 'lodash-es';

export interface BasicCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label?: React.ReactNode;
  labelPosition?: 'left' | 'right';
  id?: string;
}

export const BasicCheckbox: React.FC<BasicCheckboxProps> = ({
  label,
  labelPosition = 'right',
  id,
  className,
  ...props
}) => {
  const checkboxId = useMemo(() => id || uniqueId('checkbox-'), [id]);

  return (
    <StyledBasicCheckbox className={className}>
      {label && labelPosition === 'left' && (
        <label htmlFor={checkboxId} className="cbx">
          <span className="label-span">{label}</span>
        </label>
      )}

      <input type="checkbox" id={checkboxId} className="inp-cbx" {...props} />

      <label htmlFor={checkboxId} className="cbx">
        <span>
          <svg viewBox="0 0 12 10" height="10px" width="12px">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>

        {label && labelPosition === 'right' && <span className="label-span">{label}</span>}
      </label>
    </StyledBasicCheckbox>
  );
};
